import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "./apiRoutes";

interface UseGetTaskAttachmentListProps {
  projectId: string;
  taskId: string;
  includePresignedUrls?: boolean,
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTaskAttachmentList = async (taskId: string, projectId: string, includePresignedUrls?: boolean) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/tasks/${taskId}/attachments?includePresignedUrls=${includePresignedUrls}`);

const useGetTaskAttachmentList = ({
  taskId,
  projectId,
  includePresignedUrls,
  queryParams,
}: UseGetTaskAttachmentListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["attachment-list", taskId],
    queryFn: () => getTaskAttachmentList(taskId, projectId, includePresignedUrls),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTaskAttachmentList;
